import React from 'react';
import { Field } from '../../ui/Field';
import { TextInput } from '../../ui/TextControl';
import { asDraft } from '../../../types/registration';
import type { QuestionProps } from './types';
export function ContactQuestion({
  data,
  update
}: QuestionProps) {
  const draft = asDraft(data);
  return <div className="flex flex-col gap-5" data-id="element-432" data-mp="3sjo75kmno4tn">
      <Field name="email" label="Email address" hint="Used for sign-in and nothing else." data-id="element-433" data-mp="3skzc3nru7imc">
        <TextInput id="email" name="email" type="email" autoComplete="email" placeholder="you@example.org" value={draft.email} onChange={event => update({
        email: event.target.value
      })} data-id="element-434" data-mp="t3hk95etauv3" />
      </Field>

      <Field name="phone" label="Phone" hint="Optional — only if email doesn’t reach you." data-id="element-435" data-mp="f36t019lbe9e">
        <TextInput id="phone" name="phone" type="tel" autoComplete="tel" value={draft.phone} onChange={event => update({
        phone: event.target.value
      })} data-id="element-436" data-mp="34ulhpqls57ol" />
      </Field>

      <p className="text-small text-ink-muted" data-id="element-437" data-mp="e7l8dv2ol5f1">
        Neither is ever shown to another member, and neither is used to identify you anywhere on
        the portal.
      </p>
    </div>;
}